<template>
  <div v-if="isNative" class="cookie-banner overlay">
    <div class="cookie-banner box">
      <span class="title">{{ t("CORE.CONSENT.@TITLE") }}</span>
      <span class="description">{{ t("CORE.CONSENT.@DESCRIPTION") }}</span>
      <button class="btn btn-accept" type="button" @click="acceptCookies">{{ t("CORE.CONSENT.@ACCEPT") }}</button>
      <button class="btn btn-decline" type="button" @click="declineCookies">{{ t("CORE.CONSENT.@REFUSE") }}</button>
    </div>
  </div>
</template>

<script setup>
  import { UserStorageManager } from "@core/managers/user-storage.manager";
  import { FirebaseManager } from "@core/plugins/firebase/firebase.manager";
  import { isNative } from "@core/plugins/mobile";
  import { useI18n } from "vue-i18n";
  import { posthog } from "posthog-js";
  import { onMounted } from "vue";

  const { t } = useI18n();

  const emit = defineEmits(["hideBanner"]);

  const acceptCookies = () => {
    posthog.opt_in_capturing();
    const CookieKey = posthog.consent.storageKey;
    const CookieValue = posthog.consent.storedConsent;
    UserStorageManager.setCookie(CookieKey, CookieValue);
    FirebaseManager.updateConsent("granted");
    emit("hideBanner");
  };

  const declineCookies = () => {
    posthog.opt_out_capturing();
    const CookieKey = posthog.consent.storageKey;
    const CookieValue = posthog.consent.storedConsent;
    UserStorageManager.setCookie(CookieKey, CookieValue);
    window.dataLayer.push({
      event: "CMP_interaction",
    });
    FirebaseManager.updateConsent("denied");
    emit("hideBanner");
  };
</script>

<style scoped lang="scss">
  .cookie-banner {
    font-family: "Poppins";
    &.overlay {
      position: fixed;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.5);
      top: 0;
      left: 0;
      z-index: 10000;
    }
    &.box {
      padding: 20px;
      text-align: left;
      border-radius: 10px;
      width: 90%;
      z-index: 10000;
      color: grey;
      background-color: #fff;
      position: fixed;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
      @media screen and (min-width: 620px) {
        width: 470px;
      }
      .title {
        font-size: 14px;
        margin-top: 24px;
        display: block;
        font-weight: 800;
        color: grey;
      }
      .description {
        font-size: 12px;
        display: block;
        line-height: 18px;
        margin: 20px 0 30px;
      }
      .btn {
        &:hover {
          cursor: pointer;
        }
        &-accept {
          width: 100%;
          padding: 8px;
          color: #fff;
          background-color: $secondary;
          border: 1px solid transparent;
          border-radius: 6px;
          font-weight: 600;
        }
        &-decline {
          position: absolute;
          top: 15px;
          right: 15px;
          font-size: 10px;
          color: grey;
          background: none;
          border: 0;
        }
      }
    }
  }
</style>
